import { USER_COOKIE_REFRESH_TOKEN_NAME, USER_COOKIE_TOKEN_NAME } from 'constants/cookie';
import Cookies from 'js-cookie';

export const setCookieSecureData = (accessToken: string, refreshToken: string) => {
    if (accessToken !== undefined && refreshToken !== undefined) {
        Cookies.set(USER_COOKIE_TOKEN_NAME, accessToken, { sameSite: 'strict', secure: true });
        Cookies.set(USER_COOKIE_REFRESH_TOKEN_NAME, refreshToken, { sameSite: 'strict', secure: true });
    }
};
